import { render, staticRenderFns } from "./ChannelPartnerResults.vue?vue&type=template&id=b2bf5acc&"
import script from "./ChannelPartnerResults.vue?vue&type=script&lang=js&"
export * from "./ChannelPartnerResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports